// extracted by mini-css-extract-plugin
export default {"contents":"mF-z","sectionHeading":"nF-z"};